import { TourStep } from 'core/tour';

import { LabelsFilter } from './LabelsFilter';

import { NamespacesFilter } from './NamespacesFilter';
import { tourSteps, workloadsTourId } from '../../compute-cost/list/tourSteps';
import { ClearAllButton, Search } from '@cast/shared-search-ui';

import { Stack } from '@cast/design-system';

type Props = {
  size?: 'small';
};

export const WorkloadFilters = ({ size }: Props) => {
  const isSmall = size === 'small';

  return (
    <Stack direction="row" gap={8}>
      <Stack flexGrow={1} minWidth={0} maxWidth={982}>
        <Search size={isSmall ? 'small' : undefined} />
      </Stack>
      <TourStep
        step={tourSteps.filters}
        type={workloadsTourId}
        text="Try applying labels and choose the namespaces to help you filter and find workloads."
        highlight="shadow"
        placement="top"
        boxProps={{
          display: 'flex',
          alignItems: 'center',
          gap: isSmall ? '8px' : '20px',
        }}
      >
        <Stack flexBasis="200px">
          <NamespacesFilter size={isSmall ? 'small' : undefined} />
        </Stack>

        <Stack flexBasis="200px">
          <LabelsFilter size={isSmall ? 'sm' : undefined} />
        </Stack>
      </TourStep>
      <Stack flexBasis="84px">
        <ClearAllButton
          size={isSmall ? 'sm' : undefined}
          sx={{ minWidth: 'auto', width: '100%', whiteSpace: 'nowrap' }}
        />
      </Stack>
    </Stack>
  );
};
